import * as React from 'react';
import * as Popover from '@radix-ui/react-popover';
import { HexColorPicker } from 'react-colorful';

interface ColorPickerBadgeProps {
	color: string;
	onChange?: (newColor: string) => void;
	disabled?: boolean;
}

export const ColorPickerBadge = React.memo(({ color, onChange, disabled }: ColorPickerBadgeProps) => {
	return (
		<Popover.Root>
			{/* Trigger button - color badge */}
			<Popover.Trigger asChild>
				<button
					className={`w-8 h-8 rounded border bg-white dark:bg-gray-800 shadow-sm hover:shadow-md transition-shadow ${
						disabled ? 'pointer-events-none' : ''
					}`}
					style={{ backgroundColor: color }}
				/>
			</Popover.Trigger>

			{/* Color picker popup */}
			<Popover.Portal>
				<Popover.Content
					align='start'
					className='z-50 rounded-lg p-2 bg-white dark:bg-gray-800 shadow-xl border border-gray-200 dark:border-gray-700 animate-in fade-in zoom-in-95'
					sideOffset={8}
				>
					<HexColorPicker
						color={color}
						onChange={(newColor) => {
							if (onChange) onChange(newColor);
						}}
					/>

					<Popover.Arrow className='fill-white dark:fill-gray-800' />
				</Popover.Content>
			</Popover.Portal>
		</Popover.Root>
	);
});

ColorPickerBadge.displayName = 'ColorPickerBadge';
